import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Inline = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100%;
  margin: auto;
`;

export const Fullscreen = styled.div`
  display: flex;
  padding-left: 20px;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${ColorPalette.HEX.White};
`;

export const RappiGif = styled.img`
  height: 200px;
  width: 200px;
`;
